import { PhaseSelectDropdown } from "@/domain/phase/components/phase-select-dropdown";
import { useGetPhaseListForWorkspace } from "@/domain/phase/hooks/api/use-get-phase-list-for-workspace";

import { SelectFieldProps } from "./select-field-props";
import { SingletonSelectField } from "./singleton-select-field";

export function PhaseSelectField({ workspaceId, value, onChange, disabled }: SelectFieldProps) {
  const { phaseList } = useGetPhaseListForWorkspace({ workspaceId });

  return (
    <SingletonSelectField
      value={value}
      disabled={disabled}
      optionList={phaseList}
      renderDropdown={({ value: dropdownValue, disabled: dropdownDisabled, children }) => (
        <PhaseSelectDropdown
          workspaceId={workspaceId}
          selected={dropdownValue ? { phaseId: dropdownValue } : undefined}
          onSelect={(phase) => onChange(phase ? phase.id : "")}
          isReadOnly={dropdownDisabled}
          asChild
        >
          {children}
        </PhaseSelectDropdown>
      )}
    />
  );
}
